import React from 'react';

import { SearchContext } from './search-context';

export default class SearchLoadMore extends React.Component {
    static defaultProps = {
        label: 'Load More',
        className: ''
    }

    render() {
        const { className } = this.props;

        const btnClassNames = [
            "search-load-more",
            "btn",
            className
        ].join(" ");

        return (
            <SearchContext.Consumer>
                {({ currentPage, totalPages, setPage }) => {
                    const isLastPage = currentPage === totalPages;

                    const onClick = this.props.onClick || function () { 
                        if (!isLastPage) {
                            setPage(currentPage+1); 
                        }
                    }

                    if (this.props.children) {
                        return this.props.children({ currentPage, onClick, isLastPage}) 
                    } else {
                        return (
                            !isLastPage 
                                ? <span className={btnClassNames} onClick={onClick}>
                                    {this.props.label}
                                  </span>
                                : null
                        );
                    }
                }}
            </SearchContext.Consumer>
        );
    }
}